import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/user.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-changepwd',
  templateUrl: './changepwd.component.html',
  styleUrls: ['./changepwd.component.css']
})
export class ChangepwdComponent implements OnInit {

  public cnf_password: any;
  public new_password: any;
  userName: any;
  userEmail: any;
  ID: any;
  constructor(public usr: UserService,
    public router: Router,
    public toastr: ToastrService,
    private SpinnerService: NgxSpinnerService) {
    let a = localStorage.getItem('data');
    let b = JSON.parse(a);
    let c = JSON.parse(a);

    this.userEmail = b.email;
    this.userName = b.firstName;
    this.ID = c.user_id;
    return this.userEmail && this.userName && this.ID;
  }

  form = new FormGroup({
    ur_name: new FormControl(this.userName, null),
    ur_email: new FormControl(this.userEmail, null),
    new_password: new FormControl(this.new_password, Validators.required),
    cnf_password: new FormControl(this.cnf_password, Validators.required),
  });

  get f() {
    return this.form.controls;
  }
  ngOnInit(): void {
  }

  changeClose() {
    setTimeout(() => {
      this.router.navigate(['dashboard']);
    }, 100);
  }
  changePwd() {
    if (this.form.value.new_password != this.form.value.cnf_password) {
      this.toastr.error("Password Mismatch");
    } else {
      let obj = {
        "user_id": this.ID,
        "cnf_password": this.form.value.cnf_password,
        "new_password": this.form.value.new_password
      }
      this.SpinnerService.show();
      this.usr.changePwd(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.SpinnerService.hide();
          this.toastr.success("Password Changes Successfully");
          setTimeout(() => {
            this.router.navigate(['login']);
          }, 300);
        } else {
          this.toastr.error("Error while Changing Password");
        }
      },
        (err) => {
          console.log(err);
        }
      );
    }
  }
}
